import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import {HelperService as HelpersService} from '../../services/helper/helper.service';
import {ProjectMeasureGraphicStateService} from '../../services/project-measure-graphic-state/project-measure-graphic-state.service';
import {CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ProjectService} from '../../services/project/project.service';
import {remove, clone} from 'lodash';

@Component({
  selector: 'app-drag-drop-locations-modal',
  templateUrl: './drag-drop-locations-modal.component.html',
  styleUrls: ['./drag-drop-locations-modal.component.scss'],

})
export class DragDropLocationsModalComponent implements OnInit {

  readyToRender: boolean = false;
  locations: any;
  faTimes = faTimes;
  isDragging = false;
  isLoading = false;

  @ViewChild(CdkDropList) main: CdkDropList;

  constructor(public matDialog: MatDialog,
              private state: ProjectMeasureGraphicStateService,
              private projectService: ProjectService) {
  }

  ngOnInit() {
    const locations = this.state.get('locations');
    this.addInBetweens(locations);
    // 'workaround' to avoid bad rendering on init (when the component is in a dialog)
    // cf this unresolved issue : https://github.com/angular/components/issues/13870
    setTimeout(() => this.readyToRender = true, 200);
  }

  saveOrder() {
    this.state.updateLocations(this.removeInBetweens(this.locations, true));
  }

  drop(event: CdkDragDrop<string[]>, location: any) {
    moveItemInArray(location, event.previousIndex, event.currentIndex);
  }

  getImg(type: any) {
    return HelpersService.imageByType(type);
  }

  dropItem(event: CdkDragDrop<string[]>, group) {
    const location = event.item.data;
    if ((!location.type || location.type === 'inBetween') && group.type !== 'inBetween') {
      return;
    }
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      const parent = group.type === 'inBetween' ? null : group.id;
      this.isLoading = true;
      this.projectService.patchProjectDeviceLocation(location.id, {parent}).subscribe(
        () => this.isLoading = false, () => this.isLoading = false
      );
    }
    this.updateInBetweens(this.locations);
    this.saveOrder();
  }

  getConnectedList(): any[] {
    return this.locations.map(x => x.name);
  }

  dropGroup(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.locations, event.previousIndex, event.currentIndex);
    this.updateInBetweens(this.locations);
    this.saveOrder();
  }

  private addInBetweens(locations) {
    // we add invisible droplists ("groups" with type 'inBetween') which wrap the locations located at root level + between locations groups
    // to be able to move any location from a group to root and opposite
    // todo: other side !
    const _locations = locations.reduce(
      (acc, location, index) => {
        const previous = acc[acc.length - 1] || {};
        if (location.type) {
          if (previous.type === 'inBetween') {
            previous.child.push(location);
            return acc;
          } else {
            acc.push({child: [location], name: 'inBetween_' + index + 1, type: 'inBetween'});
            return acc;
          }
        } else {
          if (previous.type === 'inBetween') {
            acc.push(location);
            return acc;
          } else {
            acc.push({child: [], name: 'inBetween_' + index + 1, type: 'inBetween'});
            acc.push(location);
            return acc;
          }
        }
      },
      [{child: [], name: 'inBetween_0', type: 'inBetween'}]
    );

    if (_locations[_locations.length - 1].type !== 'inBetween') {
      _locations.push({child: [], name: 'inBetween_' + (_locations.length - 1), type: 'inBetween'});
    }

    this.locations = _locations;
  }

  private updateInBetweens(locations) {
    // updates 'inBetween' groups when a something has been moved
    const _locations = this.removeInBetweens(locations);
    this.addInBetweens(_locations);
  }

  private removeInBetweens(locations, removeAdditionalProps = false) {
    return locations.reduce(
      (acc, location) => {
        let _location = location;
        if (removeAdditionalProps) {
          // we only copy the object if we change it
          // a shadow  copy is enough because we only remove properties at the root level
          const _location = clone(location);
          delete _location.isBeingRemoved;
        }
        if (_location.type === 'inBetween') {
          return acc.concat(_location.child);
        } else {
          return acc.concat(_location);
        }
      },
      []
    );
  }

  createGroup(name: string) {
    this.isLoading = true;
    this.projectService.postProjectDeviceLocation(this.state.get('idProject'), {name: name}).subscribe(
      (group: any) => {
        this.isLoading = false;
        group.child = [];
        this.locations.push(group);
        this.locations.push({child: [], name: 'inBetween_' + (this.locations.length - 1), type: 'inBetween'});
        this.saveOrder();

      }, () => this.isLoading = false
    );
  }


  deleteGroup(group: any) {
    group.isBeingRemoved = true;
    this.isLoading = true;
    this.projectService.deleteProjectDeviceLocation(group.id).subscribe(
      () => {
        this.isLoading = false;
        remove(this.locations, (_group: any) => _group.id === group.id);
        this.updateInBetweens(this.locations);
        this.saveOrder();
      }, () => {
        this.isLoading = false;
        group.isBeingRemoved = false;
      }
    );
  }

}

